import { useState } from "react";
import Badge from "../../../components/ui/Badge";
import EmptyState from "../components/EmptyState";
import { isLinkUrl, maskIdNumber } from "../profileUtils";
import ui from "../../../components/ui/ui.module.css";
import styles from "../Profile.module.css";

const GovernmentIdsSection = ({ documents }) => {
  const [revealed, setRevealed] = useState({});

  if (!documents.length) return <EmptyState />;

  const toggle = (id) => setRevealed((prev) => ({ ...prev, [id]: !prev[id] }));

  return (
    <div className={ui.tableWrapper}>
      <table className={ui.table}>
        <thead>
          <tr>
            <th>Type</th>
            <th>ID number</th>
            <th>Verified</th>
            <th>File</th>
          </tr>
        </thead>
        <tbody>
          {documents.map((doc) => {
            const isShown = !!revealed[doc.id];
            return (
              <tr key={doc.id}>
                <td>
                  <div className={ui.strong}>{doc.doc_type}</div>
                  {doc.docName && doc.docName !== doc.doc_type && (
                    <div className={ui.muted}>{doc.docName}</div>
                  )}
                </td>
                <td>
                  <span className={styles.idCell}>
                    {isShown
                      ? doc.id_number || "—"
                      : maskIdNumber(doc.id_number)}
                    {doc.id_number && (
                      <button
                        type="button"
                        className={ui.iconButton}
                        onClick={() => toggle(doc.id)}
                        aria-label={
                          isShown ? "Hide ID number" : "Show ID number"
                        }
                        title={isShown ? "Hide" : "Show"}
                      >
                        <i
                          className={`bi ${isShown ? "bi-eye-slash" : "bi-eye"}`}
                        ></i>
                      </button>
                    )}
                  </span>
                </td>
                <td>
                  {doc.isValidated ? (
                    <Badge tone="green" icon="bi-check-lg">
                      Verified
                    </Badge>
                  ) : (
                    <Badge tone="gray">Not verified</Badge>
                  )}
                </td>
                <td>
                  {isLinkUrl(doc.file_url) ? (
                    <a
                      href={doc.file_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={ui.linkButton}
                    >
                      View file <i className="bi bi-box-arrow-up-right"></i>
                    </a>
                  ) : doc.file_url ? (
                    <span className={ui.muted}>File on record</span>
                  ) : (
                    <span className={ui.muted}>—</span>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default GovernmentIdsSection;
